/**
 * Extracts alpha (opacity) from a hex color string with alpha channel.
 * @param hex - Hex color string in the format #RRGGBBAA
 * @returns Alpha value between 0 (transparent) and 1 (opaque), or 1 if no alpha channel
 */
export function extractAlphaFromHex(hex: string): number {
  // Return 1 (fully opaque) if no valid hex with alpha channel
  if (!hex || hex === "transparent" || hex.length < 9) {
    return 1;
  }

  // Extract alpha channel (last 2 characters)
  const alphaHex = hex.slice(7, 9);

  // Convert hex (00-FF) to decimal (0-1)
  const alphaDecimal = parseInt(alphaHex, 16) / 255;

  return alphaDecimal;
}
